import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdviserSharedVault } from '@syfo/types/adviser.types';

/**
 * Fetch list of all shared vaults for the authenticated adviser
 * Returns array of shared vault metadata
 */
export const fetchVaultsThunk = createAsyncThunk<AdviserSharedVault[]>(
  'vaults/fetchVaults',
  async () => {
    console.log('[Vaults] Fetching shared vaults list...');
    
    const response = await fetch('/api/vaults');
    
    if (!response.ok) {
      throw new Error(`Failed to fetch vaults: ${response.status}`);
    }
    
    const data: AdviserSharedVault[] = await response.json();
    console.log(`[Vaults] Fetched ${data.length} shared vaults`);
    return data;
  }
);
